import React, { useState } from "react";
import { fromCentsToPounds } from "../../../helpers/money";
import SubscriptionCancelConfirmation from "./SubscriptionCancelConfirmation";
import { cancelSubscription, getPaginatedSubscriptions } from "../../Reducers/actions/paymentActions";
import { useDispatch, useSelector } from "react-redux";
import { getUserDisplayName } from "../../../helpers/userDisplayName";

function SubscriptionSummary({ subscription }) {
    const [showCancelSubscription, setShowCancelSubscription] = useState(false);

    const dispatch = useDispatch()
    const {
        auth_user_id,
    } = useSelector((state) => ({
        auth_user_id: state?.auth?.user?.user_id,
    }));

    const calculateNextContributionDate = (createdAt) => {
        const createdDate = new Date(createdAt); // Convert the createdAt string to a Date object
        const currentDate = new Date(); // Get the current date

        // Calculate the number of months passed since the created date
        const monthsPassed = Math.floor((currentDate.getTime() - createdDate.getTime()) / (1000 * 60 * 60 * 24 * 30));

        // Calculate the next payment date by adding the number of months passed + 1
        const nextPaymentDate = new Date(createdDate);
        nextPaymentDate.setMonth(nextPaymentDate.getMonth() + monthsPassed + 1);

        // Format the date as DD/MM/YYYY
        const day = String(nextPaymentDate.getDate()).padStart(2, '0');
        const month = String(nextPaymentDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = nextPaymentDate.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const closeCancelSubscription = () => {
        setShowCancelSubscription(false);
    }
    const openCancelSubscription = () => {
        setShowCancelSubscription(true)
    }

    const handleCancelSubscription = () => {
        const subscriptionId = subscription.subscription_reference_id;
        cancelSubscription(subscriptionId).then(() => {
            dispatch(getPaginatedSubscriptions(0, 10, auth_user_id));
            closeCancelSubscription();
        }).catch((err) => console.error(err))
    }

    return (
        <div className="subscription-summary py-16">
            {showCancelSubscription && (
                <SubscriptionCancelConfirmation
                    amount={subscription?.amount}
                    onClose={closeCancelSubscription}
                    handleCancelSubscription={handleCancelSubscription}
                    full_name={getUserDisplayName(subscription?.beneficiary)}
                />
            )}
            <div className="d-flex jcsb aic pb-4">
                <div className="fs-dark fs-regular fw-normal">
                    {getUserDisplayName(subscription?.beneficiary)}
                </div>
                <div className="ml-auto fs-regular fw-regular fg-dark">
                    {fromCentsToPounds(subscription?.amount || 0)}
                </div>
            </div>
            <div className="fg-grey7 fs-xxs ">
                Next contribution on{" "}
                {calculateNextContributionDate(subscription?.created_at)}
            </div>
            <div className="cancel-button">
                <button
                    onClick={openCancelSubscription}
                    className="btn btn-sm red-outline-btn mt-16 px-24 fs-tiny"
                >
                    <span className="button-title">Cancel Subscription</span>
                </button>
            </div>
        </div>
    );
}

export default SubscriptionSummary;
